module.exports = __webpack_public_path__ + "static/media/biometric main icon.0f416903.svg";